import { render, staticRenderFns } from "./PasswordResetFrame.vue?vue&type=template&id=9a359440&scoped=true"
import script from "./PasswordResetFrame.vue?vue&type=script&lang=ts"
export * from "./PasswordResetFrame.vue?vue&type=script&lang=ts"
import style0 from "./PasswordResetFrame.vue?vue&type=style&index=0&id=9a359440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a359440",
  null
  
)

export default component.exports